/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbEntity } from "abentity/AbEntity";
import { NestedError } from "abweb/dto/exception/NestedError";
export class EntityUserSettingsStorage {
  constructor(namespace = "AbInitio.UserSetting") {
    this.namespace = namespace;
  }
  namespacedKey(key) {
    return `${this.namespace}.${key}`;
  }
  async getValue(key) {
    try {
      const value = await AbEntity.getEntityServices().getClientUserSetting(this.namespacedKey(key));
      return value.length > 0 ? value : undefined;
    } catch (e) {
      throw new NestedError(`Failed to get value for user setting ${key} with namespace ${this.namespace}`, e);
    }
  }
  async setValue(key, value) {
    try {
      await AbEntity.getEntityServices().setClientUserSetting(this.namespacedKey(key), value);
    } catch (e) {
      throw new NestedError(`Failed to update value for user setting ${key} with namespace ${this.namespace}`, e);
    }
  }
  async removeValue(key) {
    try {
      await AbEntity.getEntityServices().deleteClientUserSetting(this.namespacedKey(key));
    } catch (e) {
      throw new NestedError(`Failed to remove user setting ${key} with namespace ${this.namespace}`, e);
    }
  }
}
//# sourceMappingURL=EntityUserSettingsStorage.js.map
